// frontend/shared-ui/src/components/Sidebar.jsx
import React from "react";
import { NavLink } from "react-router-dom";

export default function Sidebar({
  brand = "FiberHome",
  brandMark = "FH",
  sections = [],
  collapsed = false,
  open = false,
  onNavigate,
  footer = null,
}) {
  const classes = [
    "fh-sidebar",
    collapsed ? "fh-sidebar--collapsed" : "",
    open ? "fh-sidebar--open" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <aside className={classes} aria-label="Main navigation">
      <div className="fh-sidebar__brand">
        <div className="fh-sidebar__brand-mark">{brandMark}</div>
        {!collapsed && <div className="fh-sidebar__brand-text">{brand}</div>}
      </div>

      <nav className="fh-sidebar__nav fh-scroll">
        {sections.map((section, si) => (
          <div key={si}>
            {section.label && !collapsed && (
              <div className="fh-sidebar__section-label">{section.label}</div>
            )}
            {section.items.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `fh-sidebar__link ${isActive ? "fh-sidebar__link--active" : ""}`
                }
                title={collapsed ? item.label : undefined}
                onClick={() => onNavigate?.()}
              >
                <span className="fh-sidebar__icon">{item.icon}</span>
                {!collapsed && (
                  <span className="fh-sidebar__label-row">
                    <span className="fh-sidebar__label">{item.label}</span>
                    {item.badge != null && (
                      <span className="fh-sidebar__badge">{item.badge}</span>
                    )}
                  </span>
                )}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      {footer && <div className="fh-sidebar__footer">{footer}</div>}
    </aside>
  );
}
